"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDatapoolString = void 0;
function buildDatapoolString(datapoolCode, ds_type) {
    switch (ds_type) {
        case 's3':
            return "datapool-".concat(datapoolCode.toLowerCase());
        case 'cassandra':
        default:
            return "datapool_".concat(datapoolCode.toLowerCase());
    }
}
exports.buildDatapoolString = buildDatapoolString;
//# sourceMappingURL=nameUtils.js.map